module.exports = __webpack_public_path__ + "img/title.1d3608c5.png";